import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

type PlusIconButtonProps = ExtendedIconButtonProps & {
  iconColor?: 'primary' | 'inherit';
};

const PlusIconButton = forwardRef<HTMLButtonElement, PlusIconButtonProps>(
  ({ tooltipTitle, ...props }, ref) => {
    const { t } = useTranslation();
    const { iconColor = 'inherit', ...restProps } = props;
    const resolvedTooltipTitle = tooltipTitle ?? t('common.add', 'Add');

    return (
      <IconButton
        ref={ref}
        {...restProps}
        tooltipTitle={resolvedTooltipTitle}
      >
        <PlusIcon color={iconColor} />
      </IconButton>
    );
  },
);

PlusIconButton.displayName = 'PlusIconButton';
export default PlusIconButton;
